import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GnJsonFormComponent} from './json-form.component';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzInputNumberModule} from 'ng-zorro-antd/input-number';
import {NzSwitchModule} from 'ng-zorro-antd/switch';
import {GnJsonFormItemComponent} from './json-form-item/json-form-item.component';
import {GnFormModule} from '../form/form.module';
import {GnInputModule} from '../input/input.module';
import {GnPasswordModule} from '../password/password.module';
import {GnRadioModule} from '../radio/radio.module';
import {GnSelectModule} from '../select/select.module';
import {GnMessageServiceModule} from '../message-service/message-service.module';


@NgModule({
  declarations: [GnJsonFormComponent, GnJsonFormItemComponent],
  exports: [
    GnJsonFormComponent,
    GnJsonFormItemComponent
  ],
  imports: [
    CommonModule,
    NzFormModule,
    NzInputNumberModule,
    NzSwitchModule,
    GnFormModule,
    GnInputModule,
    GnRadioModule,
    GnSelectModule,
    GnPasswordModule,
    GnMessageServiceModule
  ]
})
export class GnJsonFormModule {
}
